import $ from "jquery";
$(document).ready(function () {
    // $.getJSON("/cookie-consent-data", (data) => {
    //     const CookieConsentNode = new CookieConsent(data);
    //     CookieConsentNode.init();
    // })
});
